import { FC } from 'react';

import { IAuthTypeForm } from '../../auth.interface';

import styles from './AuthHeader.module.sass';

const AuthHeaderTitle: FC<IAuthTypeForm> = ({ type }) => {
  return (
    <>
      {(type === 'phone' || type === 'code') && (
        <h2 className={styles.title}>Введите код подтверждения</h2>
      )}
      {type === 'email' && <h2 className={styles.title}>Войдите по почте</h2>}
    </>
  );
};

export default AuthHeaderTitle;
